import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SlideInOutAnimation } from '@app/my-collection/components/collection-list-table/collection-list-table.animation';
import { Observable } from 'rxjs/internal/Observable';
import { MyOrders } from '@app/core/models';
import { Store, select } from '@ngrx/store';
import { AppState } from '@app/core/ngrx';

@Component({
  selector: 'ecp-my-orders-list-table',
  templateUrl: './my-orders-list-table.component.html',
  styleUrls: ['./my-orders-list-table.component.scss'],
  animations: [SlideInOutAnimation],
})
export class MyOrdersListTableComponent implements OnInit {
  constructor(private store: Store<any>) {}
  public myorders$: Observable<MyOrders[]>;
  public loading$: Observable<boolean>;
  public searchTerm$: Observable<string>;
  public brand: any = {};
  public searchTerm = '';
  @Output() emitMyOrders = new EventEmitter<any>();

  ngOnInit(): void {
    this.myorders$ = this.store.pipe(
      select(state => (state.myOrders.list ? state.myOrders.list.orderHistoryItems : null)),
    );
    this.loading$ = this.store.pipe(select(state => state.myOrders.pending));
    this.searchTerm$ = this.store.pipe(select(state => state.myOrders.searchTerm));
    this.myorders$.pipe().subscribe();

    this.searchTerm$.subscribe(searchTerm => {
      this.searchTerm = searchTerm;
    });
    this.myorders$.pipe().subscribe(orders => {
      if (orders) this.emitMyOrders.emit(orders);
    });
  }
}
